import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import { Portal } from "components/general/Portal";
import Styles from "components/loader/Loader.module.scss";

class Loader extends Component {
  render () {
    const { props } = this;

    let _cls = [Styles["gb-loader"]];
    
    if (
      props.loader.visible === true 
      || props.queue.length > 0
    ) {
      _cls.push(Styles["visible"]);
    }

    if (typeof props.loader.type === "string" && props.loader.type.trim() !== "") {
      _cls.push(Styles[props.loader.type.trim()]);
    }

    return (
      <Portal id={"gb-loader"}>
        <div className={classnames(_cls)}>
          <svg version={"1.1"}
              xmlns={"http://www.w3.org/2000/svg"}
              viewBox={"0 0 136.2 136.5"}
              className={Styles["gb-loader-logo"]}>
            <polyline
              points={"133,71.2 68.2,6.4 6.4,68.2 68.3,130.1 118.8,79.6 68.2,29 28.9,68.3 71.1,110.5"}/>
          </svg>
        </div>
      </Portal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    queue: state.ui.queue
  };
};

Loader = connect(mapStateToProps)(Loader);

export {
  Loader
};
